export const environment = {
  production: true,
  // baseApiURL: "https://dev-test.alofoq.ly/user/api/index.php/api/",
  baseApiURL: "https://portal.alofoq.ly/user/api/index.php/api/",
  //baseApiURL: "https://dev-portal.alofoq.ly/user/api/index.php/api/",
  cdnBase: 'https://cdn.alofoq.ly/',
  privateKey: 'abcdefghijuklmno0123456789012345'
};
